import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { LineStatus } from "../../../constants";
import { TrackShipmentDetailsLines } from "../TrackShipmentDetailsLines";
import { TrackShipmentDetailsSimpleTimeline } from "../TrackShipmentDetailsSimpleTimeline";
import {
    OrderDataSource,
    UnifiedDeliveryEvent,
    UnifiedOrderLookupOrderShipment,
} from "../types";

import styles from "./index.module.scss";
import lineStyles from "./lines.module.scss";

export const ShipmentSummary = (
    props: Immutable<{
        shipment: UnifiedOrderLookupOrderShipment;
        orderSource: OrderDataSource;
        closestStep: LineStatus;
        unifiedEvents: UnifiedDeliveryEvent[];
        trackShipmentUrl: string;
        warLink: string;
    }>,
): React.JSX.Element | null => {
    const lines = props.shipment.lines;

    // Return null if the only line in this Shipment is a parent line
    if (lines.length === 1 && lines[0].is_parent_line) {
        return null;
    }
    const shouldHideTimeline = (): boolean => {
        // Check if single line with return/canceled status
        if (
            lines.length === 1 &&
            (lines[0].line_status === LineStatus.RETURN_REQUESTED ||
                lines[0].line_status === LineStatus.CANCELED ||
                lines[0].line_status === null)
        ) {
            return true;
        }

        // Check if all lines have RETURN_REQUESTED or CANCELED status
        return (
            lines.length > 0 &&
            lines.every(
                (line) =>
                    line.line_status === LineStatus.RETURN_REQUESTED ||
                    line.line_status === LineStatus.CANCELED,
            )
        );
    };

    return (
        <div className={styles.detailsContainer}>
            <div>
                <TrackShipmentDetailsLines
                    styles={lineStyles}
                    source={props.orderSource}
                    closestStep={props.closestStep}
                    lines={props.shipment.lines}
                    warLink={props.warLink}
                />
            </div>
            {!shouldHideTimeline() && (
                <div>
                    <TrackShipmentDetailsSimpleTimeline
                        unifiedEvents={props.unifiedEvents}
                    />
                    {props.closestStep !== LineStatus.PENDING &&
                    props.shipment.events.length > 0 ? (
                        <a href={props.trackShipmentUrl} className="button">
                            {t`Track Shipment`}
                        </a>
                    ) : (
                        <p className={styles.caption}>
                            Tracking information will be provided once your
                            order ships
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};
